/* ============================================================
   STREET RACING THEME — sr-theme.js
   JS global cargado en layout/theme.liquid
   ============================================================ */

/* NOTA: El menú móvil (mobile-menu-btn / mobile-menu) NO se maneja
   aquí — ya lo controla el script que viene dentro de la sección
   del header (sections/header.liquid o como se llame el snippet
   con el modal de búsqueda). Se sacó de este archivo porque había
   DOS listeners de clic sobre el mismo botón: uno aquí y otro en
   el header, y se cancelaban entre sí (el menú se abría y cerraba
   en el mismo instante). Si en algún momento el header pierde su
   propio script, hay que volver a agregar aquí el bloque de
   mobile-menu-btn — pero solo en un lugar, nunca en los dos. */

document.addEventListener('DOMContentLoaded', function () {

  /* ── POPUP ──────────────────────────────────────── */
  const popup = document.getElementById('sr-popup');
  if (popup && !sessionStorage.getItem('sr-popup-closed')) {
    const delay = (window.srPopupDelay || 5) * 1000;
    setTimeout(function () { popup.classList.add('open'); }, delay);
  }
  if (popup) {
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });
  }

  /* ── SLIDESHOW ───────────────────────────────────── */
  const hero = document.getElementById('sr-hero');
  if (hero) {
    const slides = hero.querySelectorAll('.hero-slide');
    const dots   = hero.querySelectorAll('.slide-dot');
    if (slides.length > 1) {
      const slideDelay = 5000;
      let current = 0, paused = false;
      function goTo(i) {
        slides[current].classList.remove('active');
        dots[current] && dots[current].classList.remove('active');
        current = (i + slides.length) % slides.length;
        slides[current].classList.add('active');
        dots[current] && dots[current].classList.add('active');
      }
      let timer = setInterval(function () { if (!paused) goTo(current + 1); }, slideDelay);
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          clearInterval(timer);
          goTo(parseInt(this.dataset.index));
          timer = setInterval(function () { if (!paused) goTo(current + 1); }, slideDelay);
        });
      });
      hero.addEventListener('mouseenter', function () { paused = true; });
      hero.addEventListener('mouseleave', function () { paused = false; });
    }
  }
});

/* ── POPUP FUNCTIONS ─────────────────────────────── */
function openPopup()  { document.getElementById('sr-popup')?.classList.add('open'); }
function closePopup() {
  document.getElementById('sr-popup')?.classList.remove('open');
  sessionStorage.setItem('sr-popup-closed', '1');
}

/* ── ADD TO CART ─────────────────────────────────── */
/* Actualiza el contador del carrito después de agregar un producto */
async function addToCart(variantId, btn) {
  if (!variantId) return;
  const original = btn.textContent;
  btn.classList.add('loading');
  btn.textContent = 'Agregando...';
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (res.ok) {
      btn.textContent = '¡Agregado! ✓';
      btn.style.background = '#1a7a3c';
      btn.style.borderColor = '#1a7a3c';
      updateCartCount();
      setTimeout(function () {
        btn.textContent = original;
        btn.style.background = '';
        btn.style.borderColor = '';
        btn.classList.remove('loading');
      }, 2200);
    }
  } catch (e) {
    btn.textContent = original;
    btn.classList.remove('loading');
  }
}

/* Actualiza el número del carrito en el header */
async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    ['cart-count', 'cart-count-mobile'].forEach(function (id) {
      const el = document.getElementById(id);
      if (el) el.textContent = cart.item_count;
    });
  } catch (e) {}
}